import { authRef, blockchainRef } from '../../config/firebase';
import Log from '../../utils/Log';

export const FETCH_GAME_USER = 'FETCH_GAME_USER';
export const FETCH_GAME_BAT = 'FETCH_GAME_BAT';
export const FETCH_TERMS_AGREED = 'FETCH_TERMS_AGREED';

export const fetchGameUser = () => dispatch =>
  authRef.onAuthStateChanged(user =>
    dispatch({
      type: FETCH_GAME_USER,
      payload: user || null
    }));

export const fetchGameBat = userId => async dispatch =>
  blockchainRef
  .child(userId)
  .on('value', snapshot =>
    dispatch({
      type: FETCH_GAME_BAT,
      payload: (snapshot.val()) ? snapshot.val().batSuperLeagueId : null
    }));

export const setGameBat = (userId, address, itemId, itemName, typeId, batSuperLeagueId) => async dispatch => {
  const batSkill = (typeId) ? parseInt(typeId.substring(13, 15), 10) : null;

  blockchainRef
    .child(userId)
    .update({
      'address': address,
      'itemId': itemId,
      'itemName': itemName,
      'typeId': typeId,
      'batSuperLeagueId': batSuperLeagueId,
      'batSkill': batSkill
    }, (error) => {
      if (error) {
        Log.error(`Failed to set game bat: ${error}`);
        return;
      }

      dispatch({
        type: FETCH_GAME_BAT,
        payload: batSuperLeagueId
      });
    });
  }

export const deleteGameBat = (userId) => async dispatch =>
  blockchainRef
    .child(userId)
    .update({
      'itemId': null,
      'itemName': null,
      'typeId': null,
      'batSuperLeagueId': null,
      'batSkill': null
    }, (error) => {
      if (error) {
        Log.error(`Failed to remove game bat: ${error}`);
      }

      dispatch({
        type: FETCH_GAME_BAT,
        payload: null
      });
    });

export const fetchTermsAgreed = userId => async dispatch =>
  new Promise((resolve, reject) =>
    blockchainRef
    .child(userId)
    .on('value', snapshot => {
      const termsAgreed =  snapshot.val() && snapshot.val().termsAgreed

      dispatch({
        type: FETCH_TERMS_AGREED,
        payload: termsAgreed
      });

      resolve(termsAgreed);
    })
  );

export const setTermsAgreed = (userId, termsAgreed) => async dispatch =>
  blockchainRef
    .child(userId)
    .update({
      'termsAgreed': termsAgreed
    }, (error) => {
      if (error) {
        Log.error(`Failed to set termsAgreed: ${error}`);
        return;
      }

      dispatch({
        type: FETCH_TERMS_AGREED,
        payload: termsAgreed
      });
    });



// WEBPACK FOOTER //
// ./src/redux/actions/firebaseActions.js